import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  margin-left: 9px;
  user-select: none;
`;
export const IconWrap = styled.div<{ isInteractive?: boolean }>`
  position: relative;
  z-index: 3;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 7px 15px rgba(72, 69, 50, 0.15);
  cursor: ${({ isInteractive }) => (isInteractive ? "pointer" : "inherit")};
`;
export const Count = styled.span`
  text-align: center;
  font-size: 13px;
  height: 20px;
  min-width: 14px;
  z-index: 2;
  padding: 3px 5px 0px 7px;
  position: relative;
  left: -4px;
  font-weight: 700;
  color: #b7a3c3;
  background-color: white;
  color: #b7a3c3;
  border-radius: 12px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  box-shadow: 0 7px 15px rgba(72, 69, 50, 0.15);
`;
